// fortune.js - 占いフォーム完全統合版
// DOM商品取得、占いシステム、Twitter シェア全て含む

(function() {
    'use strict';
    
    // ==========================================
    // プライベート変数
    // ==========================================
    let fortuneExecuted = false;
    let lastExecuteTime = 0;
    
    // ==========================================
    // ユーティリティ関数
    // ==========================================
    
    // JavaScript用文字列エスケープ関数
    function escapeForJS(str) {
        if (!str) return '';
        return str.replace(/\\/g, '\\\\')
                 .replace(/'/g, "\\'")
                 .replace(/"/g, '\\"')
                 .replace(/\n/g, '\\n')
                 .replace(/\r/g, '\\r')
                 .replace(/\t/g, '\\t');
    }
    
    // ==========================================
    // DOM商品情報取得システム
    // ==========================================
    
    // 既存のコレクションページから商品情報を取得
    function getCurrentCollectionProducts() {
        const products = [];
        
        // 一般的なShopifyテーマの商品セレクター
        const productSelectors = [
            '.product-item',
            '.product-card', 
            '.grid__item',
            '[data-product-id]',
            '.product',
            '.collection-product',
            '.product-grid-item'
        ];
        
        let productElements = [];
        
        // 複数のセレクターを試して商品要素を取得
        for (const selector of productSelectors) {
            productElements = document.querySelectorAll(selector);
            if (productElements.length > 0) {
                console.log(`Found ${productElements.length} products using selector: ${selector}`);
                break;
            }
        }
        
        if (productElements.length === 0) {
            console.warn('No product elements found. Please check product selectors.');
            return [];
        }
        
        // 各商品要素から情報を抽出
        productElements.forEach((element, index) => {
            try {
                const productInfo = extractProductInfo(element);
                if (productInfo) {
                    products.push(productInfo);
                }
            } catch (error) {
                console.warn(`Error extracting product info from element ${index}:`, error);
            }
        });
        
        console.log(`Extracted ${products.length} products from DOM`);
        return products;
    }
    
    // 複数のセレクターで要素を検索
    function findElementBySelectors(parent, selectors) {
        for (const selector of selectors) {
            const element = parent.querySelector(selector);
            if (element) {
                return element;
            }
        }
        return null;
    }
    
    // 商品要素から情報を抽出
    function extractProductInfo(element) {
        const productInfo = {};
        
        // 商品タイトルを取得
        const titleSelectors = [
            '.product-title', '.product-name', '.card-title', 'h3', 'h2', 
            '.title', '[data-product-title]', 'a[href*="/products/"]'
        ];
        const titleElement = findElementBySelectors(element, titleSelectors);
        if (titleElement) {
            productInfo.title = titleElement.textContent.trim();
        }
        
        // 商品リンク（ハンドル）を取得
        const linkElement = element.querySelector('a[href*="/products/"]') || 
                           element.closest('a[href*="/products/"]');
        if (linkElement) {
            const href = linkElement.getAttribute('href');
            productInfo.url = href;
            const handleMatch = href.match(/\/products\/([^/?]+)/);
            if (handleMatch) {
                productInfo.handle = handleMatch[1];
            }
        }
        
        // 商品画像を取得
        const imageSelectors = [
            '.product-image img', '.card-image img', 'img[src*="products"]', 
            'img[alt*="product" i]', 'img'
        ];
        const imageElement = findElementBySelectors(element, imageSelectors);
        if (imageElement) {
            productInfo.image = imageElement.getAttribute('src') || imageElement.getAttribute('data-src');
        }
        
        // 価格を取得
        const priceSelectors = ['.product-price', '.price', '.card-price', '[data-price]', '.money'];
        const priceElement = findElementBySelectors(element, priceSelectors);
        if (priceElement) {
            productInfo.price = priceElement.textContent.trim();
        }
        
        // 在庫状況を判定
        productInfo.available = !element.classList.contains('sold-out') && 
                               !element.classList.contains('unavailable') &&
                               !element.querySelector('.sold-out');
        
        // 商品IDを取得
        const productId = element.getAttribute('data-product-id') || element.getAttribute('data-id');
        if (productId) {
            productInfo.id = productId;
        }
        
        // 最低限の情報があるかチェック
        if (productInfo.title && (productInfo.handle || productInfo.url)) {
            return productInfo;
        }
        
        return null;
    }
    
    // 柔軟な商品検索（代替名・英語名対応）
    function findProductByCardFlexible(cardName, collectionProducts) {
        // 1. 完全一致を最優先で検索
        let matchingProduct = collectionProducts.find(product => {
            const productTitle = product.title.toLowerCase();
            return productTitle.includes(cardName.toLowerCase());
        });
        
        if (matchingProduct) return matchingProduct;
        
        // 2. 代替名での検索
        const alternativeNames = {
            '法王': ['教皇', 'ハイエロファント', 'hierophant'],
            '女教皇': ['女司祭', 'ハイプリエステス', 'high priestess'],
            '吊るされた男': ['吊り人', 'ハングドマン', 'hanged man'],
            '運命の輪': ['ホイール', '運命', 'wheel of fortune', 'wheel'],
            '審判': ['ジャッジメント', '最後の審判', 'judgement', 'judgment']
        };
        
        if (alternativeNames[cardName]) {
            for (const altName of alternativeNames[cardName]) {
                matchingProduct = collectionProducts.find(product => {
                    const productTitle = product.title.toLowerCase();
                    return productTitle.includes(altName.toLowerCase());
                });
                if (matchingProduct) return matchingProduct;
            }
        }
        
        // 3. 英語名での検索
        const englishNames = {
            '愚者': 'fool', '魔術師': 'magician', '女教皇': 'high priestess',
            '女帝': 'empress', '皇帝': 'emperor', '法王': 'hierophant',
            '恋人': 'lovers', '戦車': 'chariot', '力': 'strength',
            '隠者': 'hermit', '運命の輪': 'wheel of fortune', '正義': 'justice',
            '吊るされた男': 'hanged man', '死神': 'death', '節制': 'temperance',
            '悪魔': 'devil', '塔': 'tower', '星': 'star',
            '月': 'moon', '太陽': 'sun', '審判': 'judgement', '世界': 'world'
        };
        
        if (englishNames[cardName]) {
            matchingProduct = collectionProducts.find(product => {
                const productTitle = product.title.toLowerCase();
                return productTitle.includes(englishNames[cardName]);
            });
        }
        
        return matchingProduct;
    }
    
    // カード名に対応する商品を検索
    function getProductInfoByCard(cardName) {
        const collectionProducts = getCurrentCollectionProducts();
        
        if (!collectionProducts || collectionProducts.length === 0) {
            console.log('No collection products found in DOM');
            return null;
        }
        
        const matchingProduct = findProductByCardFlexible(cardName, collectionProducts);
        
        if (matchingProduct) {
            console.log(`Found matching product for ${cardName}:`, matchingProduct.title);
            return matchingProduct;
        }
        
        console.log(`No matching product found for card: ${cardName}`);
        return null;
    }
    
    // ==========================================
    // 占いフォームシステム
    // ==========================================
    
    // メイン実行関数
    function handleFortuneSubmit() {
        if (fortuneExecuted) {
            alert('占いは既に実行されています。ページをリロードしてから再度お試しください。');
            return;
        }
        
        const currentTime = Date.now();
        if (currentTime - lastExecuteTime < 5000) {
            alert('少し時間をおいてから再度お試しください。');
            return;
        }
        
        const formData = getFormData();
        if (!validateFormData(formData)) return;
        
        lastExecuteTime = currentTime;
        
        const button = document.querySelector('.contact__button button');
        disableForm(button);
        
        submitToAPI(formData, button);
    }
    
    // フォームデータ取得
    function getFormData() {
        return {
            gender: document.getElementById('FortuneForm-gender').value,
            concern: document.getElementById('FortuneForm-concern').value,
            cardNumber: document.getElementById('FortuneForm-card').value
        };
    }
    
    // バリデーション関数を修正
    function validateFormData(data) {
        if (!data.gender) {
            alert('性別を選択してください');
            return false;
        }
        if (!data.concern.trim()) {
            alert('お悩みを入力してください');
            return false;
        }
        if (data.concern.trim().length > 200) { // 文字数制限を緩和
            alert('お悩みは200文字以内で入力してください');
            return false;
        }
        if (!data.cardNumber) {
            alert('カード番号を選択してください');
            return false;
        }
        return true;
    }
    
    // フォーム無効化
    function disableForm(button) {
        button.textContent = '占い中...';
        button.disabled = true;
        
        ['FortuneForm-gender', 'FortuneForm-concern', 'FortuneForm-card'].forEach(id => {
            const element = document.getElementById(id);
            if (element) element.disabled = true;
        });
    }
    
    // API送信
    function submitToAPI(formData, button) {
        const requestData = {
            ...formData,
            cardNumber: parseInt(formData.cardNumber),
            timestamp: Date.now()
        };
        
        // Cloud Functions エンドポイント（実際のURLに変更してください）
        const API_ENDPOINT = 'https://piacetto-1oracle-api-410017080957.us-central1.run.app://REGION-PROJECT_ID.cloudfunctions.net/fortuneReading';
        
        fetch(API_ENDPOINT, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify(requestData)
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.json();
        })
        .then(data => {
            if (data.success) {
                handleSuccess(data.result, button);
            } else {
                throw new Error(data.error);
            }
        })
        .catch(error => handleError(error, button));
    }
    
    // 成功時処理
    function handleSuccess(result, button) {
        fortuneExecuted = true;
        
        displayResult(result);
        
        button.textContent = 'ページをリロードして再度占う';
        button.onclick = () => {
            if (confirm('ページをリロードしますか？')) {
                location.reload();
            }
        };
    }
    
    // エラー時処理
    function handleError(error, button) {
        console.error('Error:', error);
        alert('占いの処理中にエラーが発生しました。ページをリロードしてから再度お試しください。');
        
        button.textContent = 'ワンオラクルで占う';
        button.disabled = false;
        ['FortuneForm-gender', 'FortuneForm-concern', 'FortuneForm-card'].forEach(id => {
            const element = document.getElementById(id);
            if (element) element.disabled = false;
        });
    }
    
    // ==========================================
    // 結果表示システム
    // ==========================================
    
    // 結果表示
    function displayResult(result) {
        let resultArea = document.getElementById('fortune-result');
        if (!resultArea) {
            resultArea = document.createElement('div');
            resultArea.id = 'fortune-result';
            resultArea.className = 'fortune-result-area';
            document.querySelector('.contact__button').parentNode.appendChild(resultArea);
        }
        
        resultArea.innerHTML = createResultHTML(result);
        resultArea.style.display = 'block';
        
        setTimeout(() => {
            resultArea.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }, 100);
    }
    
    // 結果HTML生成
    function createResultHTML(result) {
        const productInfo = getProductInfoByCard(result.card.name);
        
        return `
            <div class="fortune-result-content">
                <h2 style="text-align: center; margin: 0 0 20px 0;">占い結果</h2>
                
                <div class="card-info">
                    <h2 class="card-name">${result.card.name}</h2>
                    <p class="card-meaning">基本的な意味: ${result.card.meaning}</p>
                </div>
                
                <div class="interpretation">
                    <p>${result.interpretation}</p>
                </div>
                
                ${productInfo ? createProductSection(productInfo, result.card.name) : ''}
                
                <div class="share-section">
                    <button onclick="shareToX('${result.card.name}', '${escapeForJS(result.interpretation)}', '${productInfo ? escapeForJS(productInfo.title) : ''}', '${escapeForJS(result.card.meaning)}')" class="x-share-btn">
                        <svg viewBox="0 0 24 24" fill="currentColor">
                            <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
                        </svg>
                        で結果をシェア
                    </button>
                </div>
            </div>
        `;
    }
    
    // 商品セクションのHTML生成（既存DOM要素をクローン）
    function createProductSection(productInfo, cardName) {
        if (!productInfo) return '';
        
        // 元の商品要素（li.grid__item）を検索
        const originalGridItem = findOriginalProductElement(productInfo);
        
        if (originalGridItem) {
            // 元のli要素をクローンして返す
            const clonedGridItem = originalGridItem.cloneNode(true);
            
            // クローンした要素のIDを一意にする（重複を避けるため）
            updateClonedElementIds(clonedGridItem);
            
            // グリッドクラスを取得（グリッドシステムは無効化するが、スタイル継承のため）
            const originalGrid = document.getElementById('product-grid');
            const gridClasses = originalGrid ? Array.from(originalGrid.classList).join(' ') : 'grid product-grid';
            
            return `
                <div class="product-recommendation">
                    <ul class="${gridClasses}">
                        ${clonedGridItem.outerHTML}
                    </ul>
                </div>
            `;
        } else {
            // フォールバック：元の要素が見つからない場合はシンプルな表示
            const productUrl = productInfo.url.startsWith('/') ? productInfo.url : `/products/${productInfo.handle}`;
            
            return `
                <div class="product-recommendation">
                    <a href="${productUrl}" class="recommended-product card--media">
                        ${productInfo.image ? 
                            `<img src="${productInfo.image}" alt="${productInfo.title}" loading="lazy">` :
                            '<div style="width:100%;height:300px;background:#f0f0f0;display:flex;align-items:center;justify-content:center;color:#666;">画像なし</div>'
                        }
                        <div class="card-information">
                            <h5>${productInfo.title}</h5>
                            <div class="price">${productInfo.price || ''}</div>
                        </div>
                    </a>
                </div>
            `;
        }
    }
    
    // 元の商品要素（li.grid__item）を検索
    function findOriginalProductElement(productInfo) {
        // li.grid__itemを直接検索
        const gridItems = document.querySelectorAll('li.grid__item');
        
        for (const gridItem of gridItems) {
            // グリッドアイテム内の商品要素を検索
            const productElement = gridItem.querySelector('.card-wrapper');
            if (!productElement) continue;
            
            // タイトルによる照合
            const titleElement = findElementBySelectors(productElement, [
                '.card__heading a', '.product-title', '.product-name', '.card-title', 'h3', 'h2', 
                '.title', '[data-product-title]', 'a[href*="/products/"]'
            ]);
            
            if (titleElement && titleElement.textContent.trim() === productInfo.title) {
                return gridItem; // li.grid__item を返す
            }
            
            // URLによる照合
            const linkElement = productElement.querySelector('a[href*="/products/"]');
            if (linkElement && productInfo.url) {
                const href = linkElement.getAttribute('href');
                if (href === productInfo.url || (productInfo.handle && href.includes(productInfo.handle))) {
                    return gridItem; // li.grid__item を返す
                }
            }
            
            // 商品IDによる照合
            if (productInfo.id) {
                const elementId = productElement.getAttribute('data-product-id') || 
                                  productElement.getAttribute('data-id') ||
                                  gridItem.getAttribute('data-product-id') || 
                                  gridItem.getAttribute('data-id');
                if (elementId === productInfo.id) {
                    return gridItem; // li.grid__item を返す
                }
            }
        }
        
        return null;
    }
    
    // クローンした要素のIDを一意にする
    function updateClonedElementIds(element) {
        const timestamp = Date.now();
        const randomSuffix = Math.random().toString(36).substr(2, 9);
        const uniqueSuffix = `fortune-${timestamp}-${randomSuffix}`;
        
        // 自身のIDを更新
        if (element.id) {
            element.id = `${element.id}-${uniqueSuffix}`;
        }
        
        // 子要素のIDとaria-labelledby属性を更新
        const elementsWithIds = element.querySelectorAll('[id]');
        elementsWithIds.forEach(el => {
            const oldId = el.id;
            const newId = `${oldId}-${uniqueSuffix}`;
            el.id = newId;
            
            // aria-labelledby属性を持つ要素も更新
            const referencingElements = element.querySelectorAll(`[aria-labelledby*="${oldId}"]`);
            referencingElements.forEach(refEl => {
                const ariaLabelledBy = refEl.getAttribute('aria-labelledby');
                refEl.setAttribute('aria-labelledby', ariaLabelledBy.replace(oldId, newId));
            });
        });
    }
    
    // ==========================================
    // Twitterシェアシステム
    // ==========================================
    
    // Twitterシェア機能
    function shareToX(cardName, interpretation, productName, cardMeaning) {
        // APIから取得したカードの意味を分割
        const meanings = cardMeaning ? cardMeaning.split('、') : ['神秘', '運命', '導き'];
        
        // チェックマーク大付きの意味リストを作成
        const meaningsList = meanings.map(meaning => `☑️ ${meaning}`).join('\n');
        
        const text = `あなたにぴったりのアミュレットは…
${productName || cardName}
${meaningsList}
を意味する【${cardName}】をモチーフにしたアクセサリー💎
🔮ピアチェットの #アミュレット診断`;
        
        // カード名に応じた記事URLを取得
        const url = getCardArticleUrl(cardName);
        
        const xUrl = `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(url)}`;
        
        window.open(xUrl, 'x-share', 'width=550,height=420,scrollbars=yes,resizable=yes');
    }
    
    // カード名から記事URLを取得する関数
    function getCardArticleUrl(cardName) {
        const cardUrlMap = {
            '愚者': 'https://piacetto.online/blogs/tarot/fool',
            '魔術師': 'https://piacetto.online/blogs/tarot/magician',
            '女教皇': 'https://piacetto.online/blogs/tarot/high-priestess',
            '女帝': 'https://piacetto.online/blogs/tarot/empress',
            '皇帝': 'https://piacetto.online/blogs/tarot/emperor',
            '法王': 'https://piacetto.online/blogs/tarot/hierophant',
            '恋人': 'https://piacetto.online/blogs/tarot/lovers',
            '戦車': 'https://piacetto.online/blogs/tarot/chariot',
            '力': 'https://piacetto.online/blogs/tarot/strength',
            '隠者': 'https://piacetto.online/blogs/tarot/hermit',
            '運命の輪': 'https://piacetto.online/blogs/tarot/wheel-of-fortune',
            '正義': 'https://piacetto.online/blogs/tarot/justice',
            '吊るされた男': 'https://piacetto.online/blogs/tarot/hanged-man',
            '死神': 'https://piacetto.online/blogs/tarot/death',
            '節制': 'https://piacetto.online/blogs/tarot/temperance',
            '悪魔': 'https://piacetto.online/blogs/tarot/devil',
            '塔': 'https://piacetto.online/blogs/tarot/tower',
            '星': 'https://piacetto.online/blogs/tarot/star',
            '月': 'https://piacetto.online/blogs/tarot/moon',
            '太陽': 'https://piacetto.online/blogs/tarot/sun',
            '審判': 'https://piacetto.online/blogs/tarot/judgement',
            '世界': 'https://piacetto.online/blogs/tarot/world'
        };
        
        return cardUrlMap[cardName] || 'https://piacetto.online/collections/amulet';
    }
    
    // ==========================================
    // デバッグ・初期化システム
    // ==========================================
    
    // デバッグ用: 商品マッピング状況確認
    function debugProductMapping() {
        const collectionProducts = getCurrentCollectionProducts();
        const tarotCards = [
            '愚者', '魔術師', '女教皇', '女帝', '皇帝', '法王', '恋人', '戦車', 
            '力', '隠者', '運命の輪', '正義', '吊るされた男', '死神', '節制', 
            '悪魔', '塔', '星', '月', '太陽', '審判', '世界'
        ];
        
        console.log('=== DOM商品マッピング状況 ===');
        console.log(`ページ内商品数: ${collectionProducts.length}`);
        
        if (collectionProducts.length > 0) {
            console.log('取得された商品一覧:');
            collectionProducts.forEach((product, index) => {
                console.log(`${index + 1}. ${product.title} (${product.handle || 'handle不明'})`);
            });
        }
        
        const mappingResults = {};
        tarotCards.forEach(cardName => {
            const product = findProductByCardFlexible(cardName, collectionProducts);
            mappingResults[cardName] = product ? product.title : '対応商品なし';
        });
        
        console.table(mappingResults);
        return mappingResults;
    }
    
    // 初期化
    function init() {
        // デバッグモード
        const urlParams = new URLSearchParams(window.location.search);
        if (urlParams.get('debug') === 'true') {
            console.log('Debug mode enabled - DOM Product Detection');
            setTimeout(debugProductMapping, 1000);
        }
    }
    
    // ==========================================
    // グローバル公開
    // ==========================================
    
    window.handleFortuneSubmit = handleFortuneSubmit;
    window.shareToX = shareToX;
    window.debugProductMapping = debugProductMapping; // デバッグ用
    
    // DOM読み込み完了時に初期化
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
})();